module.exports = __webpack_public_path__ + "static/media/C15.8efa322f.png";